import { colors } from '../../style';

export type ActionIconButtonVariants = 'inherit' | 'action' | 'clean';

export const variants = {
  inherit: {
    background: 'rgba(0, 0, 0, 0.05)',
    activeBackground: 'rgba(0, 0, 0, 0.1)',
    hoverBackground: 'rgba(0, 0, 0, 0.07)',
    color: 'inherit',
    disabledColor: 'inherit',
    disabledOpacity: 0.5,
    disabledBackgroundColor: 'rgba(0, 0, 0, 0.05)',
  },
  action: {
    background: 'action',
    activeBackground: 'actionColorDark',
    hoverBackground: 'actionColorDark',
    color: colors.white,
    disabledColor: colors.gray600,
    disabledOpacity: 1,
    disabledBackgroundColor: colors.gray400,
  },
  clean: {
    background: colors.transparent,
    activeBackground: 'actionLight',
    hoverBackground: colors.gray100,
    color: colors.gray900,
    disabledColor: colors.gray600,
    disabledOpacity: 1,
    disabledBackgroundColor: colors.transparent,
  },
};

export const getBackgroundColor = ({
  variant,
  actionColor,
}: {
  variant: ActionIconButtonVariants;
  actionColor: string;
}) => {
  if (variant === 'action') {
    return actionColor;
  }
  return variants[variant].background;
};

export const getColor = ({ variant }: { variant: ActionIconButtonVariants }) => {
  return variants[variant].color;
};

export const getHoverBackgroundColor = ({
  variant,
  actionColorDark,
}: {
  variant: ActionIconButtonVariants;
  actionColorDark: string;
}) => {
  if (variant === 'action') {
    return actionColorDark;
  }
  return variants[variant].hoverBackground;
};

export const getActiveBackgroundColor = ({
  variant,
  actionColorDark,
  actionLight,
}: {
  variant: ActionIconButtonVariants;
  actionColorDark: string;
  actionLight: string;
}) => {
  if (variant === 'action') {
    return actionColorDark;
  }

  if (variant === 'clean') {
    return actionLight;
  }

  return variants[variant].activeBackground;
};

export const getDisabledColor = ({ variant }: { variant: ActionIconButtonVariants }) => {
  return variants[variant].disabledColor;
};
export const getDisabledBackgroundColor = ({ variant }: { variant: ActionIconButtonVariants }) => {
  return variants[variant].disabledBackgroundColor;
};

export const getDisabledOpacity = ({ variant }: { variant: ActionIconButtonVariants }) => {
  return variants[variant].disabledOpacity;
};
